import React from "react";
import AttendanceRecordsShared from "../attendance/AttendanceRecordsShared";

export default function SupervisorAttendanceRecords() {
  return <AttendanceRecordsShared backPath="/supervisor/attendance" />;
}
